import React, {useEffect} from "react";
import NavBar from "../components/Navbar";
import styles from "../styles/screens/AboutUs.module.css";
import temple from "../assets/ic_temple.png";
import Footer from "../components/Footer";

import adarshImage from "../assets/team/adarsh.png";
import adityaImage from "../assets/team/aditya.png";
import sanklapImage from "../assets/team/sanklap.png";
import { useTranslation } from "react-i18next";
import Metadata from "../components/metadata/MetaData";
import { usePostHog } from 'posthog-js/react'

const AboutUs = () => {
  const { t } = useTranslation();
  const posthog = usePostHog();

  useEffect(() => {
    posthog.capture('$pageview');
  }, [posthog]);

  return (
    <div>
    <Metadata
        description="Celebrate Holi with the divine blessings of Shri Krishna! Order sacred Vrindavan Holi Prasad and Banke Bihari Temple offerings online. The Vrindavan Holi Prasad Box brings the sacred essence of Vrindavan to your home anywhere in India, including prasad from Shri Banke Bihari Temple, blessed tulsi mala, Krishna Ji moorti, and more. Get Holi 2025 Prasad, Holi Prasad Boxes, and divine blessings delivered to your doorstep. Immerse yourself in Krishna’s love and joy this Holi with spiritual Holi rituals, puja offerings, and Braj Holi traditions from Mathura and Vrindavan."
        keywords="Vrindavan Holi Prasad, Online Prasad Booking, Banke Bihari Holi Prasad, Holi 2025 Prasad, Braj Holi Offerings, Krishna Temple Prasad, Mathura Holi Prasad, Divine Prasad Home Delivery, Holi Blessings, Radha Krishna Holi, Spiritual Holi Traditions, Gulaal Offerings, Holi Bhog, Holi Prasad Service, Order Prasad Online, Holi Rituals in Vrindavan, Holi Puja Offerings, Buy Banke Bihari Prasad Online, Order Banke Bihari Temple Prasad, Online Banke Bihari Prasad Delivery, Vrindavan Holi Prasad Online, Holi Prasad Box Online, Sacred Holi Prasad Delivery, Banke Bihari Holi Prasad Box, Vrindavan Temple Prasad Online, Online Prasad from Banke Bihari Mandir, Buy Vrindavan Prasad Online for Holi, Holi Festival Offerings from Vrindavan, Krishna Bhog Prasad Online, Temple Prasad Home Delivery for Holi, Authentic Vrindavan Prasad Box, Online Delivery of Holi Prasad in India, Holi Special Prasad from Vrindavan Temples, Order Sacred Prasad from Vrindavan Temples, Banke Bihari Mandir Holi Offerings Online, Holi Prasad Gift Box from Vrindavan, Vrindavan Devotional Prasad for Holi, Mathura Holi, Mathura Holi 2025, Mathura Holi Dates 2025, Vrindavan Holi 2025, Barsana Holi 2025, Mathura Vrindavan Holi 2025, Brij Holi, Barsana Holi, Nandgaon Holi, Gokul Holi, Mahavan Holi, Goverdhan Holi, Holi, Huranga Holi, Vrindavan Holi, Brindavan Holi, Mathura Holi Calendar, India Holi, Braj Holi 2025 Schedule, Mathura Holi Schedule 2025, Holi Schedule, Colorful Festival Mathura Vrindavan, Bankey Bihari Temple Holi, Krishna Janmabhoomi Temple Holi, Lathmar Holi, Barsana Lathmar Holi, Phoolan Holi, Holi Festival Braja, Holi Celebration in Vrindavan, Charity on Holi, Holi Rituals, Lord Krishna Holi, Spring Festival, Spiritual Holi Celebration, Holi Charity Significance, Vrindavan Holi Traditions, Colors of Holi, Holi in Braja, Vrindavan Festival, Holi Prayers, Holi in Braja Region, Vrindavan Holi Customs, Holi Dance and Music, Holi Festivities in Vrindavan, Holi Community Celebrations, Holi in the Birthplace of Krishna, Holi Devotional Activities, Holi Festival of Love, Charity and Holi, Holi Color Festival, Devotional Holi Celebration, Vrindavan Holi Atmosphere, Holi in the Land of Krishna, Holi Worship and Prayers, Phool Wali Holi, Radha Krishna Holi, Widow's Holi, Holi in Mathura, Holi Traditions, Laddu Mar Holi, Holika Dahan, Dhulandi Holi, Holi Celebrations in India, Braj Region Holi, Krishna Holi Festival, Unique Holi Traditions, Holi Rituals in Braj."
        ogTitle="Order Vrindavan Holi Prasad Online | Banke Bihari Temple Offerings for Holi 2025"
        ogDescription="Celebrate Holi with the divine blessings of Shri Krishna! Order sacred Vrindavan Holi Prasad and Banke Bihari Temple offerings online. The Vrindavan Holi Prasad Box brings the sacred essence of Vrindavan to your home anywhere in India, including prasad from Shri Banke Bihari Temple, blessed tulsi mala, Krishna Ji moorti, and more. Get Holi 2025 Prasad, Holi Prasad Boxes, and divine blessings delivered to your doorstep. Immerse yourself in Krishna’s love and joy this Holi with spiritual Holi rituals, puja offerings, and Braj Holi traditions from Mathura and Vrindavan."
        ogImage="https://d3vqmpzcil03dt.cloudfront.net/webite-assets/dharmik_logo.png"
        ogUrl="https://dharmikapp.in/dharmikx"
        canonicalUrl="https://dharmikapp.in/dharmikx"
        twitter="@dharmikapp"
        youtube="@dharmik_hindi"
        instagram="@dharmik_app"
        author="Dharmik App"
        publisher="Dharmik"
        datePublished="2025-03-08"
       />
      <NavBar />
      <div style={{ backgroundColor: "#fff1ea" }}>
        <div className={styles.icon_text}>
          <img
            src={temple}
            alt={t("Temple Icon")}
            className={styles.icon}
          ></img>
          <h1 className={styles.title}>{t("About Us")}</h1>
        </div>
        <div className={styles._text}>
          <p>{t("About Us Description")}</p>
          <h2>{t("Spiritual Journey Heading")}</h2>
          <p>{t("Spiritual Journey Description")}</p>
        </div>
        <div className={styles.icon_text}>
          <img
            src={temple}
            alt={t("Temple Icon")}
            className={styles.icon}
          ></img>
          <h1 className={styles.title}>{t("Meet Our Team")}</h1>
        </div>
        <div className={styles.teamProfiles}>
          <div className={styles.teamProfile}>
            <img
              src={adarshImage}
              alt={t("Adarsh Goyal Alt")}
              className={styles.profileImage}
            />
            <h3>{t("Adarsh Goyal Name")}</h3>
            <p>{t("Adarsh Goyal Title")}</p>
            <p>{t("Adarsh Goyal Description")}</p>
          </div>
          <div className={styles.teamProfile}>
            <img
              src={adityaImage}
              alt={t("Aditya Rana Alt")}
              className={styles.profileImage}
            />
            <h3>{t("Aditya Rana Name")}</h3>
            <p>{t("Aditya Rana Title")}</p>
            <p>{t("Aditya Rana Description")}</p>
          </div>
          <div className={styles.teamProfile}>
            <img
              src={sanklapImage}
              alt={t("Sanklap Asawa Alt")}
              className={styles.profileImage}
            />
            <h3>{t("Sanklap Asawa Name")}</h3>
            <p>{t("Sanklap Asawa Title")}</p>
            <p>{t("Sanklap Asawa Description")}</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
